const SkeletonRow = ({ columns = 6 }) => (
  <tr className="border-b border-[var(--bright-gray)]">
    {Array.from({ length: columns }).map((_, i) => (
      <td key={i} className="py-[15px] px-[15px]">
        <div className="h-4 bg-gray-200 rounded animate-pulse" />
      </td>
    ))}
  </tr>
);

const TableSkeleton = ({ rows = 5, columns = 6, className = '' }) => {
  return (
    <div className={`${className} bg-white rounded-[6px] border border-[var(--bright-gray)] overflow-hidden`}>
      <div className="py-[20px] px-[20px] border-b border-[var(--bright-gray)]">
        <div className="flex gap-4 items-center">
          <div className="h-6 w-48 bg-gray-200 rounded animate-pulse" />
          <div className="ml-auto flex gap-4">
            <div className="h-8 w-64 bg-gray-200 rounded animate-pulse" />
            <div className="h-8 w-32 bg-gray-200 rounded animate-pulse" />
          </div>
        </div>
      </div>
      <table className="w-full">
        <thead>
          <tr className="bg-[var(--lotion)] border-b border-[var(--bright-gray)]">
            {Array.from({ length: columns }).map((_, i) => (
              <th key={i} className="py-[15px] px-[15px] text-left">
                <div className="h-4 w-20 bg-gray-300 rounded animate-pulse" />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, i) => (
            <SkeletonRow key={i} columns={columns} />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableSkeleton;
